import { Route, Routes, BrowserRouter } from 'react-router-dom';
import RoutesItems from "./routes";


function App() {
  return (
    <div className="App">
      <BrowserRouter >
        <Routes>
          {
            RoutesItems.map((routeConfig, i) => {
              return (
                <Route path={routeConfig.path} exact={routeConfig.exact} element={routeConfig.element} key={i} />
              )
            })
          }

        </Routes>
      </BrowserRouter >


    </div>
  );
}

export default App;
